<template>
  <div><div class="chat-bot-modal" v-if="visible">
<!--  <div class="backdrop" @click.self="closeModal" >-->
    <div class="chat-bot-modal" :class="[bottomRightMode ? 'modal-bottom-right' : 'modal-center']">
      <div class="chat-bot-modal__header shadow gradient-dark">
        <div class="title">
          <h3>Let's talk</h3>
        </div>
        <div class="actions">
          <div class="action">
<!--            <font-awesome-icon style="transform: rotate(90deg)" v-if="bottomRightMode" @click="switchMode" icon="up-right-and-down-left-from-center" transform=""></font-awesome-icon>-->
<!--            <font-awesome-icon style="transform: rotate(90deg)" v-else @click="switchMode" icon="down-left-and-up-right-to-center" transform=""></font-awesome-icon>-->
          </div>
          <div class="action">

            <b-btn-close
                class="d-none d-sm-inline-block" @click.stop="closeModal">  <span aria-hidden="true">&times;</span> </b-btn-close>
          </div>
        </div>
      </div>
      <div class="chat-bot-modal__body">
        <div class="messages">
          <div class="messages-inner" id="messageBody">

            <div v-for="message in messages" :key="message.id" class="message" :class="[message.from === 'Silena' ? 'from-bot' : 'from-user']">
              <div class="message-inner" v-if="message.type === 'smartActionLinks'">

                <div class="list-group"
                     ref="actionsList">
                  <div :class="'list-group-item smart-search-item' + (selectedSmartActionId === action.id ? ' active' : '') "  v-for="action in message.actions"
                       :key="action.id"
                       tabindex="0"
                       @mouseover="selectedSmartActionId = action.id "
                       :data-action-id="action.id" @click="executeSmartAction(action)"
                  >
                    <font-awesome-layers>
                      <font-awesome-icon v-if="action.iconModifier"  transform="shrink-3 left-3 up-3" :icon="action.icon"></font-awesome-icon>
                      <font-awesome-icon v-else :icon="action.icon"></font-awesome-icon>
                      <font-awesome-icon v-if="action.iconModifier" transform="shrink-5 right-6 down-6" :icon="action.iconModifier"></font-awesome-icon>
                    </font-awesome-layers>
                    <span class="pl-1" v-html="action.filledLabel"></span>
                  </div>
                </div>

              </div>
              <div class="message-inner" v-else>
                <small class="message-owner">{{message.from}} - {{message.date}} </small>
                <div class="message-inner-color">
                  <span>{{message.text}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!hasOptions" class="chat-bot-control-container">
<!--          <input  type="text" class="chat-bot-control form-control" v-model="message" @keyup.enter="sendMessage" :disabled="closed || pending" autofocus>-->
<!--          <button class="chat-bot-send-btn" @click="sendMessage" :disabled="closed || pending">Send</button>-->
          <input ref="userInput" type="text" data-test-path="chat-bot-input-bar" class="chat-bot-control form-control" v-model="message" @keyup.enter="sendMessage" autofocus>
          <button class="chat-bot-send-btn" @click="sendMessage">Send</button>
        </div>
        <div v-else-if="hasOptions && this.inputOptions.length > 4" class="chat-bot-control-container" :class="chatBotControlContainerClasses">
            <button v-for="msg in tilesRange" :key="msg" class="chat-bot-send-btn mx-2 my-1 py-2" @click="sendMessageFromOptions(msg)">{{msg}}</button>
            <div class="chat-bot-control-container">
              <button  class="chat-bot-send-btn m-1 col py-2" @click="loadPreviousTiles" v-if="firstRenderTiles !== 0"> <- </button>
              <button  class="chat-bot-send-btn m-1 col py-2" @click="loadNextTiles" v-if="firstRenderTiles + 3 < this.inputOptions.length"> -> </button>
            </div>
        </div>
        <div v-else-if="hasOptions && this.inputOptions.length === 2 && this.inputOptions[0] === 'Yes' " class="chat-bot-control-container" >
            <button v-for="msg in inputOptions" :key="msg" class="chat-bot-send-btn m-1 col py-2" @click="sendMessageFromOptions(msg)">{{msg}}</button>
        </div>
        <div v-else class="chat-bot-control-container" :class="chatBotControlContainerClasses">
            <button v-for="msg in inputOptions" :key="msg" class="chat-bot-send-btn m-1 py-2" @click="sendMessageFromOptions(msg)">{{msg}}</button>
        </div>
      </div>
    </div>
<!--  </div>-->
  </div></div>

</template>

<script>
import Rpc from "@/Rpc";
import moment from "moment-timezone";
import {registerChatBotComponent, startChatBotFromSearch} from "@/components/chatBot/ChatBotTools";
import RemoteActions from "@/components/chatBot/rcontroll/RemoteActions";
import fillActionWithData, {executeAction} from "@/components/dashboard/SmartActions";
import fillActionWithCustomData from "@/components/dashboard/SmartActions";

moment.suppressDeprecationWarnings = true;

export default {
  name: "ChatBotModal",
  data() {
    return {
      selectedSmartActionId: -1,
      visible: false,
      pending: true,
      closed: false,
      messages: [],
      message: '',
      bottomRightMode: true,
      hasOptions: false,
      inputOptions: null,
      chatBotControlContainerClasses: "",
      firstRenderTiles: 0,
      lastRenderTiles: 3
    }
  },

  async mounted() {
    registerChatBotComponent(this);
    //this.scrollToBottom()
    this.messages = [];
    this.message = '';
    this.pending = false;
    this.closed = false;
    this.nextId = 1;

  },
  created() {
    this.remoteActions = new RemoteActions();
  },
  computed: {
      tilesRange() {
          if(this.firstRenderTiles + 3 < this.inputOptions.length){
              return this.inputOptions.slice(this.firstRenderTiles, this.lastRenderTiles);
          }
          else {
              return this.inputOptions.slice(this.firstRenderTiles);
          }
      }
  },
  methods: {
    show() {
      this.visible = true;
      setTimeout(() => {
        this.$refs.userInput.focus();
      });
    },
    closeModal() {
      this.visible = false;
    },
    loadNextTiles() {
      this.firstRenderTiles += 3;
      this.lastRenderTiles += 3;
    },
    loadPreviousTiles() {
        this.firstRenderTiles -= 3;
        this.lastRenderTiles -= 3;
    },
    resetChat() {
      this.scrollToBottom()
      this.messages = [];
      this.message = '';
      this.pending = false;
      this.closed = false;
      this.nextId = 1;
      this.hasOptions = false;
      setTimeout(() => {
        this.$refs.userInput.focus();
      });

    },
    async continueChat(uuid, msg) {
      this.uuid = uuid;
      this.message = msg;
      await this.sendMessage(null, true);
    },

    executeSmartAction(action) {
      let actionId = action.id;

      // for (let i = 0; i < this.actions.length; i++) {
      //   if (this.actions[i].id === parseInt(actionId)) {
        Rpc.Actions.reportActionHit(action.requestUUID, actionId).then();
        executeAction(action);
        this.closeModal();
//      }
    },

    async startChat(){
      this.resetChat();

      let response = await Rpc.Bot.startPlot("MainPlot");
      this.uuid = response.uuid;
      const msgFromBot = response.message;
      await this.remoteActions.process(msgFromBot);
      if(msgFromBot.messageType !== "EMPTY_MESSAGE") {
        for (let textEntry of msgFromBot['textMessages']) {
          this.messages.push({text: textEntry, from: 'Silena', date: this.makeDate()})
        }
      }
      if(!msgFromBot.readInput && !closed){
        await this.sendMessage(this.message = '', true);
      }
    },

    switchMode() {
      this.bottomRightMode = !this.bottomRightMode
    },
    scrollToBottom() {

      const container = this.$el.querySelector('#messageBody');
      if(container) {
        this.$nextTick(() => {
          // DOM updated
          container.scrollTop = container.scrollHeight;
        });
      }
    },
    makeDate(){
      return new moment().format("HH:mm");
    },

    addSilenaMessage(textEntry){
      this.messages.push({text: textEntry, from:'Silena', id: this.nextId++, date:this.makeDate()})
    },
    addUserMessage(textEntry){
      this.messages.push({text: textEntry, from:'User', id: this.nextId++, date:this.makeDate()})
    },
    async sendMessageFromOptions(msg){
        this.message = ''

        this.scrollToBottom()
        this.pending = true;
        let res = await Rpc.Bot.interact(this.uuid, msg);
        this.pending = false;
        let closed = false;
        /**
         * @type {OutputMessage}
         */
        const msgFromBot = res.message;
        if(msgFromBot.messageType !== "EMPTY_MESSAGE") {
            for (let textEntry of msgFromBot['textMessages']) {
                this.messages.push({text: textEntry, from: 'Silena', id: this.nextId++, date: this.makeDate()})
            }
        }
        await this.remoteActions.process(msgFromBot);

        if(msgFromBot.smartActions && msgFromBot.smartActions.length){
            for(let action of msgFromBot.smartActions){
                fillActionWithData(action);
            }
            this.messages.push({type:"smartActionLinks", from:'Silena', id: this.nextId++, date:this.makeDate(), actions: msgFromBot.smartActions});
        }

        if(msgFromBot.customData && Object.keys(msgFromBot.customData).length){
            this.inputOptions = []
            for(let [key, value] of Object.entries(msgFromBot.customData)){
                // console.log(`${key}: ${value}`);
                this.inputOptions.push(value);
            }
            this.hasOptions = msgFromBot.hasOptions;
            this.chatBotControlContainerClasses = "flex-column mb-5";
            this.firstRenderTiles = 0;
            this.lastRenderTiles = 3;
        }
        this.hasOptions = msgFromBot.hasOptions;

        closed = closed || msgFromBot.action === "END";

        this.scrollToBottom()
        this.closed = closed;
        if(!msgFromBot.readInput && !closed){
            await this.sendMessage(this.message = '', true);
        }
    },
    async sendMessage(event, silent=false) {
      if(!this.message && !silent) {
        return
      }
      if(!silent) {
        this.messages.push({
          text: this.message,
          from: 'You',
          date: this.makeDate()
        })
      }

      let msg = this.message;
      this.message = ''

      this.scrollToBottom()
      this.pending = true;
      let res = await Rpc.Bot.interact(this.uuid, msg);
      this.pending = false;
      let closed = false;
      /**
       * @type {OutputMessage}
       */
      const msgFromBot = res.message;
      if(msgFromBot.messageType !== "EMPTY_MESSAGE") {
        for (let textEntry of msgFromBot['textMessages']) {
          this.messages.push({text: textEntry, from: 'Silena', id: this.nextId++, date: this.makeDate()})
        }
      }
      await this.remoteActions.process(msgFromBot);

      if(msgFromBot.smartActions && msgFromBot.smartActions.length){
        for(let action of msgFromBot.smartActions){
          fillActionWithData(action);
        }
        this.messages.push({type:"smartActionLinks", from:'Silena', id: this.nextId++, date:this.makeDate(), actions: msgFromBot.smartActions});
      }

      if(msgFromBot.customData && Object.keys(msgFromBot.customData).length){
        this.inputOptions = []
        for(let [key, value] of Object.entries(msgFromBot.customData)){
            // console.log(`${key}: ${value}`);
            this.inputOptions.push(value);
        }

        this.hasOptions = msgFromBot.hasOptions;
        this.chatBotControlContainerClasses = "flex-column mb-5";

        this.firstRenderTiles = 0;
        this.lastRenderTiles = 3;
      }
      this.hasOptions = msgFromBot.hasOptions;

      closed = closed || msgFromBot.action === "END";

      this.scrollToBottom()
      this.closed = closed;
      if(!msgFromBot.readInput && !closed){
        await this.sendMessage(this.message = '', true);
      }
    }
  }
}
</script>